const cacheStorage = []

export default {
  name: 'DataProvider',
  props: {
    url: { type: String, required: true },
    method: { type: String, default: 'GET' },
    options: { type: Object, default: () => {} },
    manually: { type: Boolean, default: false },
    cache: { type: Boolean, default: false }
  },
  data () {
    return {
      data: null,
      error: null,
      loading: false
    }
  },
  methods: {
    async fetch (url, method, options = {}) {
      method = method.toLowerCase()
      if (!url || !this.$http[method] || this.loading) {
        return
      }

      this.loading = true
      try {
        // const { data } = await this.$http[method](url, options)
        let data = null
        data = await this.getCache(url, method, options)
        if (!data) {
          const response = await this.$http({
            url,
            method,
            ...options
          })
          data = response.data
          this.setCache(url, method, options, JSON.parse(JSON.stringify(data)))
        }
        this.data = data
        this.error = null
        this.$emit('loaded', JSON.parse(JSON.stringify(data)))
      } catch (err) {
        this.data = null
        this.error = err.response
        this.$emit('error', err.response)
      }
      this.loading = false
    },
    setCache (url, method, options, data) {
      if (!this.cache) {
        return
      }
      cacheStorage.push([url, method, JSON.stringify(options), JSON.parse(JSON.stringify(data))])
    },
    getCache (url, method, options) {
      if (!this.cache) {
        return new Promise((resolve) => resolve(null))
      }
      const record = cacheStorage.find((row) => (row[0] === url && row[1] === method && row[2] === JSON.stringify(options)))
      return new Promise((resolve) => {
        if (!record || !record.length) {
          resolve(null)
        } else {
          resolve(record[record.length - 1])
        }
      })
    },
    load () {
      return this.fetch(this.url, this.method, this.options)
    }
  },
  created () {
    if (!this.manually) {
      this.load()
    }
  },
  render () {
    const slot = this.$scopedSlots.default({
      data: this.data,
      error: this.error,
      load: this.load,
      loading: this.loading
    })
    return Array.isArray(slot) ? slot[0] : slot
  }
}
